<template>
    <div>

        <div class="float-right m-2">
            Search:
            <search-box :list="dataItems" :filteredList="filteredList" :fields="['name', 'country', 'city', 'zip', 'street_address']" ></search-box>
        </div>

        <table class="table table-borderless">

            <thead>
                <tr>
                    <th>Name <sort-button style="color:blue" field="name" :list="dataItems"></sort-button> </th>
                    <th>Country <sort-button style="color:blue" field="country" :list="dataItems"></sort-button> </th>
                    <th>City <sort-button style="color:blue" field="city" :list="dataItems"></sort-button> </th>
                    <th>Post office number <sort-button style="color:blue" field="zip" :list="dataItems"></sort-button> </th>
                    <th>Street Address <sort-button style="color:blue" field="street_address" :list="dataItems"></sort-button> </th>
                    <th>Actions</th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="(item, key) in filteredList" :key="key">

                    <td>
                        <!-- This should be dropdown -->
                        <div class="form-group">
                            <input class="form-control border border-dark" placeholder="name" type="text" v-model.lazy.trim="item.name" required />
                        </div>
                    </td>

                    <td>
                        <!-- This should be dropdown -->
                        <div class="form-group">
                            <input class="form-control border border-dark" placeholder="country" type="text" v-model.lazy.trim="item.country" required />
                        </div>
                    </td>

                    <td>
                        <div class="form-group">
                            <input class="form-control border border-dark" placeholder="city" type="text" v-model.lazy.trim="item.city" required />
                        </div>
                    </td>

                    <td>
                        <div class="form-group">
                            <input class="form-control border border-dark" placeholder="post number" type="text" v-model.lazy.trim="item.zip" required />
                        </div>
                    </td>

                    <td>
                        <div class="form-group">
                            <input
                                class="form-control border border-dark"
                                placeholder="street address"
                                type="text"
                                v-model.lazy.trim="item.street_address"
                                required />
                        </div>
                    </td>

                    <td>
                        <update-button :user-permissions="userPermissions" @click="onUpdate(item)" > Save </update-button>
                        <delete-button :user-permissions="userPermissions" @click="onDelete(item)"> Delete </delete-button>
                    </td>

                </tr>
            </tbody>
        </table>

        <add-button :user-permissions="userPermissions" @click="onAdd({'addressable_type' : addressableType})"> New Address </add-button>
        <status-feedback :successFeedback="successFeedback" :failFeedback="failFeedback" :errors="errors" ></status-feedback>

    </div>
</template>

<script>

import AjaxListMixin from '../mixins/AjaxListMixin';
import TableComponentsMixin from '../mixins/TableComponentsMixin';
import PermissionButtons from '../mixins/PermissionButtonsMixin';

export default{

    mixins: [AjaxListMixin, TableComponentsMixin, PermissionButtons],

    props: {

        items: {
            type: Array,
            default : () => {return [];}
        },

        addressableType: {
            type: String,
            required: true,
        },

        addressUrl: {
            type: String,
            default: 'address',
        }

    },

    data() {

        return {
            url: this.addressUrl,
            dataItems: this.items,
            filteredList: [],
        };
    }

};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/organizations/AddressComponent.vue